import React from "react";
import { Link } from "react-router-dom";
import { communityGroups} from "../../pages/CommunityPage";

// Community Section Component
const CommunitySection = () => {
    const communityItems = communityGroups.slice(0,3);
    const handleClick = () => {
        window.scrollTo(0, 0);
    };

    return (
        <div className="px-4 md:px-20 py-16 bg-white/5">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-8 md:mb-12 text-center">
                Our Community
            </h2>
            <div className="flex flex-col md:flex-row justify-center space-y-6 md:space-y-0 md:space-x-8">
                {communityItems.map((item, index) => (
                    <div
                        key={index}
                        className="w-full md:w-80 bg-white/20 backdrop-blur-lg border border-white/30 rounded-3xl overflow-hidden shadow-xl transform transition-all duration-300 md:hover:scale-105"
                    >
                        <img
                            src={item.imageUrl}
                            alt={item.title}
                            className="w-full h-48 object-cover"
                        />
                        <div className="p-6">
                            <h3 className="text-xl md:text-2xl font-semibold text-white mb-4">
                                {item.title}
                            </h3>
                            <p className="text-white/80 mb-6">
                                {item.description}
                            </p>
                            <Link to={item.link} onClick={handleClick}>
                                <button className="w-full bg-white/20 text-white py-3 rounded-full hover:bg-white/30 transition-colors">
                                    Explore
                                </button>
                            </Link>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CommunitySection;